<template>
    <el-row v-if="" style="align: center" class="row" v-loading="isLoading">
        <el-row class="row change-end-user-info-title-wrapper">
            <el-button @click="backToMyPage" id="back_button"><i class="el-icon el-icon-arrow-left"></i></el-button>
            <h1 id="change_end_user_info_title">{{$t('changeEndUserInfo.headerTitle')}}</h1>
        </el-row>

        <el-col class="vertical-center change-base-info" style="height: 100%">
            <el-form v-loading="loading">
                <el-form-item prop="name" :label="$t('changeEndUserInfo.nameTitle')" style="font-weight: bold">
                    <el-input v-model="endUserBaseInfo.name" @change="checkDisableUpdateButton" ref="name" type="text"
                              :placeholder="$t('changeEndUserInfo.namePlaceholder')"
                              autocomplete="disabled"
                              aria-autocomplete="none"></el-input>
                    <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="isNotFilled.name">
                        {{$t("common.requiredMessage")}}</p>
                </el-form-item>

                <SelectDate ref="selectDate" @triggerToValidateData="triggerToValidateDataFromSelectDate"></SelectDate>
                <p style="color: red; margin-top: -3px; margin-bottom: 0; font-weight: bold; font-size: 14px"
                   v-show="isNotFilled.birthDay">{{$t("common.requiredMessage")}}</p>

                <el-form-item prop="national" :label="$t('changeEndUserInfo.nationalTitle')" style="font-weight: bold">
                    <el-select v-model="endUserBaseInfo.nationalCode" @change="checkDisableUpdateButton"
                               style="width: 100%" type="text"
                               :placeholder="$t('changeEndUserInfo.nationalPlaceholder')">
                        <el-option disabled value="">{{$t('changeEndUserInfo.nationalPlaceholder')}}</el-option>
                        <el-option v-for="national in nationals" :value="national.code" :label="national.name">
                            {{national.name}}
                        </el-option>
                    </el-select>
                    <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="isNotFilled.nationalCode">
                        {{$t("common.requiredMessage")}}</p>
                </el-form-item>

                <el-form-item prop="gender" :label="$t('changeEndUserInfo.genderTitle')" style="font-weight: bold">
                    <div style="width: 100%; margin-left: 0; display: inline-block;" class="gender-select">
                        <input name="gender" v-model="endUserBaseInfo.gender" type="radio" value="OTHER">
                        <label style="font-weight: normal" @click="setGender('OTHER')">{{$t('changeEndUserInfo.otherGender')}}</label>
                        <input name="gender" v-model="endUserBaseInfo.gender" type="radio" value="MALE"
                               style="margin-left: 30px">
                        <label style="font-weight: normal" @click="setGender('MALE')">{{$t('changeEndUserInfo.maleGender')}}</label>
                        <input name="gender" v-model="endUserBaseInfo.gender" type="radio" value="FEMALE"
                               style="margin-left: 30px">
                        <label style="font-weight: normal" @click="setGender('FEMALE')">{{$t('changeEndUserInfo.femaleGender')}}</label>
                    </div>
                    <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="isNotFilled.gender">
                        {{$t("common.requiredMessage")}}</p>
                </el-form-item>

                <el-form-item prop="phone" :label="$t('changeEndUserInfo.phoneTitle')" style="font-weight: bold">
                    <el-input v-model="endUserBaseInfo.phone" type="text"
                              :placeholder="$t('changeEndUserInfo.phonePlaceholder')"
                              autocomplete="disabled"
                              aria-autocomplete="none"></el-input>
                </el-form-item>

                <el-form-item prop="isAllowedToReceiveEmail" :label="$t('changeEndUserInfo.acceptEmailTitle')"
                              style="font-weight: bold">
                    <el-checkbox v-model="endUserBaseInfo.allowedToReceiveEmail" style="width: 100%">
                        {{$t('changeEndUserInfo.acceptEmailDescription')}}
                    </el-checkbox>
                </el-form-item>

                <el-form-item style="text-align: center; width: 100%">
                    <el-button style="width: 50%; background-color: #4B86E8; color: white" @click="updateEndUserInfo"
                               :disabled="disabledUpdateButton">{{$t('changeEndUserInfo.updateButton')}}
                    </el-button>
                </el-form-item>

                <el-form-item style="text-align: center; width: 100%">
                    <el-button style="width: 50%" @click="backToMyPage">{{$t('changeEndUserInfo.backButton')}}
                    </el-button>
                </el-form-item>

            </el-form>
        </el-col>
    </el-row>
</template>

<script>
    import UserAPI from "../../api/user/UserApi";
    import Auth from "../../security/Authentication";
    import AlertService from "../../service/alert.service";
    import SelectDate from "../../components/SelectDate";

    export default {
        name: "ChangeEndUserInformation",
        components: {SelectDate},
        data() {
            return {
                loading: false,
                endUserBaseInfo: {
                    name: null,
                    phone: null,
                    birthDay: null,
                    nationalCode: null,
                    gender: null,
                },

                isNotFilled: {
                    name: false,
                    birthDay: false,
                    nationalCode: false,
                    gender: false
                },

                nationals: [],
                disabledUpdateButton: false,
                isLoading: false
            }
        },

        created() {
            UserAPI.getNations().then(result => {
                this.nationals = result;
            })

            if (Auth.isAuthenticated()) {
                UserAPI.getBaseInfo(Auth.getCurrentUser().code).then(result => {
                    console.log("Base info:")
                    console.log(result)

                    this.endUserBaseInfo = result;
                    this.endUserBaseInfo.birthDay = this.$moment(new Date(this.endUserBaseInfo.birthDay)).format('YYYY-MM-DD');
                    this.disabledUpdateButton = !this.validateData(this.endUserBaseInfo);
                    this.$refs.selectDate.setSelectedDate(this.endUserBaseInfo.birthDay);
                })
            }
        },

        methods: {
            setGender(gender) {
                this.endUserBaseInfo.gender = gender;
            },
            triggerToValidateDataFromSelectDate(date) {
                this.endUserBaseInfo.birthDay = date;
                this.validateData(this.endUserBaseInfo);
            },

            updateEndUserInfo() {
                if (this.validateData(this.endUserBaseInfo)) {
                    this.isLoading = true;
                    //Call API change data
                    this.endUserBaseInfo.birthDay = this.$moment(new Date(this.endUserBaseInfo.birthDay)).format('YYYY/MM/DD HH:mm:ss');
                    UserAPI.updateBaseInfo(this.endUserBaseInfo).then(result => {
                        this.isLoading = false;
                        if (result) {
                            this.endUserBaseInfo = result;
                            this.endUserBaseInfo.birthDay = this.$moment(new Date(this.endUserBaseInfo.birthDay)).format('YYYY-MM-DD');
                            AlertService.success(this.$t('common.updateSuccess'))
                        } else {
                            AlertService.success(this.$t('common.updateFailed'))
                        }
                    })
                }
            },

            validateData(endUserBaseInfo) {
                let vm = this;
                let isEnoughInfo = true;
                if (endUserBaseInfo.name == null || endUserBaseInfo.name.trim() === "") {
                    vm.isNotFilled.name = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.name = false;
                }

                if (endUserBaseInfo.birthDay == null || !new Date(endUserBaseInfo.birthDay).getTime()) {
                    vm.isNotFilled.birthDay = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.birthDay = false;
                }

                if (endUserBaseInfo.nationalCode == null || endUserBaseInfo.nationalCode.trim() === "") {
                    vm.isNotFilled.nationalCode = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.nationalCode = false;
                }

                if (endUserBaseInfo.gender == null || endUserBaseInfo.gender.trim() === "") {
                    vm.isNotFilled.gender = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.gender = false;
                }

                return isEnoughInfo;
            },

            checkDisableUpdateButton() {
                if (!this.validateData(this.endUserBaseInfo)) {
                    this.disabledUpdateButton = true;

                } else {
                    this.disabledUpdateButton = false;
                }
            },

            backToMyPage() {
                this.$router.push({path: "/myPage"})
            }
        }
    }
</script>

<style scoped lang="scss">
    .change-base-info {
        width: 40%;
        min-width: 400px;
        margin: auto;
    }

    #back_button:hover {
        background-color: white;
    }

    #change_end_user_info_title {
        font-weight: bold;
        font-size: 30px;
        text-align: center;
        width: 75%;
        margin-right: 10%
    }

    #back_button {
        font-size: 30px;
        border: none;
        width: 15%;
        text-align: left;
        float: left
    }

    .change-end-user-info-title-wrapper {
        width: 50%;
        margin-left: 25%;
        margin-right: 25%
    }

    @media only screen and (max-width: 450px) {
        .change-base-info {
            min-width: auto;
            width: 100%;
        }

        #change_end_user_info_title {
            font-weight: bold;
            font-size: 20px;
            text-align: center;
            width: 75%;
            float: right;
        }

        .change-end-user-info-title-wrapper {
            width: 100%;
            margin-left: 0%;
            margin-right: 0%;

        }

        #back_button {
            width: 10%;
            text-align: left;
            float: left;
            font-size: 20px;
        }
    }

    .gender-select * {
        cursor: pointer;
    }
</style>
